import React from 'react';
import { Assessment } from '../../../support/assessments';
import { AssessmentLayoutProps } from './types';
import DefaultAssessmentLayout from './DefaultAssessmentLayout';
import CommandCenterLayout from './CommandCenterLayout';

/**
 * Registry of assessment layouts, keyed by the string stored in `assessment.metadata.layout`.
 *
 * Adding a full-page skin is a matter of writing a component against `AssessmentLayoutProps` and
 * registering it here — no route, no App.tsx, no change to `AssessmentFill`. An unknown or missing
 * key falls back to the default form, so an assessment authored before layouts existed (or with a
 * typo) still renders.
 */
const REGISTRY: Record<string, React.ComponentType<AssessmentLayoutProps>> = {
  default: DefaultAssessmentLayout,
  form: DefaultAssessmentLayout,
  // `full_page` is the key the seeded demo writes; `command_center` names the same skin.
  full_page: CommandCenterLayout,
  command_center: CommandCenterLayout,
};

export type { AssessmentLayoutProps } from './types';

export const layoutKeyOf = (assessment: Assessment | null | undefined): string => {
  const key = assessment?.metadata?.layout;
  return typeof key === 'string' && key in REGISTRY ? key : 'default';
};

export const getAssessmentLayout = (
  assessment: Assessment | null | undefined
): React.ComponentType<AssessmentLayoutProps> => REGISTRY[layoutKeyOf(assessment)];
